import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import template from './template.vue';

@Component({
    mixins: [template],
    components: {},
})
export default class Actions extends Vue {
    isHidden = false;
    @Prop()
    isPriority: boolean;
    @Prop()
    orderId: string;

    setPriority(isPriority: boolean) {
        let params = {};
        params = {
            order_id: this.orderId,
            is_priority: isPriority ? 'N' : 'Y', // if is priority, then need to set to not priority
        };
        this.$emit('setPriority', params);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/shipments-4-shippers/components/shipments/components/actions/index.ts